import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

interface StyleProps {
  open?: boolean;
  width?: number;
}

const openedMixin = (theme: Theme, width: number) => ({
  width,
  top: 56,
  paddingTop: 14,
  paddingLeft: 8,
  height: 'calc(100vh - 56px)',
  zIndex: 1002,
  overflowX: 'hidden' as const,
  overflowY: 'hidden' as const,
  backgroundColor: theme.palette.background.default,
});

const closedMixin = (theme: Theme) => ({
  zIndex: 2,
  overflowX: 'hidden' as const,
  backgroundColor: theme.palette.background.default,
  width: 30,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

export default makeStyles((theme: Theme) => ({
  drawer: (props: StyleProps) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap' as const,
    boxSizing: 'border-box' as const,
    ...(props.open
      ? {
          ...openedMixin(theme, props.width ?? 240),
          '& .MuiDrawer-paper': openedMixin(theme, props.width ?? 240),
        }
      : {
          ...closedMixin(theme),
          '& .MuiDrawer-paper': closedMixin(theme),
        }),
  }),
  resizeHandle: {
    width: '6px',
    cursor: 'col-resize',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
    '&:hover, &:active': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  drawerIcon: {
    position: 'fixed',
    top: 422,
    border: '1px solid rgba(255, 255, 255, 0.12)',
    padding: '4px',
    backgroundColor: theme.palette.background.paper,
  },
}));
